import './modalWrapper.scss';

import UN from '../../.././assets/images/icons/unauthorized.png';

import React, { FunctionComponent } from 'react';
import { useAppDispatch } from '../../../features';
import { setModalSignInUp } from '../../../store/AppSlice';
import { modalTypeEnum } from '../../../types/modal';

interface ModalBadPasswordProps {
    message: string;
}

export const ModalBadPassword: FunctionComponent<ModalBadPasswordProps> = ({message}) => {
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setModalSignInUp(modalTypeEnum.deviceLogin))
    }

    return (
        <div className="modal modal401">
            <div className="img">
                <img src={UN} alt="" />
            </div>
            <div className="title">
                Senha invalida!
                <small>
                    Tente uma nova senha.
                    <br></br>
                    Lembre-se, a senha de protecao foi definida no primeiro acesso a conta neste dispositivo.
                </small>
            </div>
            <div className="title dashed">
                Motivo
            </div>
            <div className="message">
                {message}
            </div>
            <button className="button" onClick={handleClick}>Fechar</button>
        </div>
    )
}